import sanityClient from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

const useMock = true;

const mockClient = {
  fetch: (query) => {
    console.log('Fetching mock data for query:', query);
    const isFrench = query.includes('_lang_fr');

    if (query.includes('experiences')) {
      if (isFrench) {
        return Promise.resolve([
          {
            year: '10/2025 – 01/2026',
            works: [
              {
                name: 'Data Scientist – NLP & LLM',
                company: 'Pangea summit - Paris',
                desc: '• Structuration de données métiers afin d’en améliorer la qualité et l’exploitabilité\n• Analyse de données complexes pour répondre à des besoins opérationnels et décisionnels\n• Optimisation de flux de données utilisés dans des systèmes automatisés\n• Évaluation de la fiabilité et de la cohérence des données exploitées\n• Collaboration avec des équipes transverses pour aligner data, outils et processus',
              },
            ],
          },
          {
            year: '05/2025 – 08/2025',
            works: [
              {
                name: 'Consultant Data IA / Développeur Code & No-Code',
                company: 'CompetitivIA - Andorre',
                desc: '• Analyse de processus opérationnels afin d’identifier des leviers d’amélioration et de digitalisation\n• Structuration de bases de données clients et métiers pour fiabiliser les informations de référence\n• Automatisation de flux de données et de reportings pour sécuriser les opérations récurrentes\n• Intégration de APIs et outils métiers pour renforcer l’interopérabilité des systèmes\n• Rédaction de documentations et modes opératoires facilitant l’adoption des outils par les équipes',
              },
            ],
          },
          {
            year: '09/2024 – 12/2024',
            works: [
              {
                name: 'Data Analyst',
                company: 'Isssa - Nice',
                desc: '• Collecte de données clients et opérationnelles issues de sources multiples afin de fiabiliser les référentiels\n• Structuration de données de référence pour assurer cohérence, traçabilité et qualité des informations clients\n• Analyse de la performance commerciale via KPI et indicateurs de suivi opérationnel\n• Mise à jour de reportings Power BI pour le pilotage des activités et le support aux équipes métiers\n• Communication de résultats analytiques à des interlocuteurs non techniques avec vulgarisation des données',
              },
            ],
          },
        ]);
      }
      return Promise.resolve([
        {
          year: '10/2025 – 01/2026',
          works: [
            {
              name: 'Data Scientist – NLP & LLM',
              company: 'Pangea summit - Paris',
              desc: '• Structuring business data to improve quality and usability\n• Analyzing complex data to meet operational and decision-making needs\n• Optimizing data flows used in automated systems\n• Evaluating the reliability and consistency of exploited data\n• Collaborating with cross-functional teams to align data, tools, and processes',
            },
          ],
        },
        {
          year: '05/2025 – 08/2025',
          works: [
            {
              name: 'AI Data Consultant / Code & No-Code Developer',
              company: 'CompetitivIA - Andorra',
              desc: '• Analyzing operational processes to identify improvement and digitalization levers\n• Structuring client and business databases to ensure reference information reliability\n• Automating data flows and reporting to secure recurring operations\n• Integrating APIs and business tools to reinforce system interoperability\n• Writing documentation and operating procedures to facilitate tool adoption by teams',
            },
          ],
        },
        {
          year: '09/2024 – 12/2024',
          works: [
            {
              name: 'Data Analyst',
              company: 'Isssa - Nice',
              desc: '• Collecting client and operational data from multiple sources to ensure repository reliability\n• Structuring reference data to ensure consistency, traceability, and quality of client information\n• Analyzing commercial performance via KPIs and operational tracking indicators\n• Updating Power BI reports for activity steering and business team support\n• Communicating analytical results to non-technical stakeholders with data simplification',
            },
          ],
        },
      ]);
    }
    if (query.includes('skills')) {
      return Promise.resolve([
        { name: 'Python', bgColor: '#edf2f8', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg' },
        { name: 'R', bgColor: '#edf2f8', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/r/r-original.svg' },
        { name: 'PyTorch', bgColor: '#edf2f8', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/pytorch/pytorch-original.svg' },
        { name: 'TensorFlow', bgColor: '#edf2f8', icon: 'https://cdn.jsdelivr.net/gh/devicons/devicon/icons/tensorflow/tensorflow-original.svg' },
        { name: 'Scikit-learn', bgColor: '#edf2f8', icon: 'https://upload.wikimedia.org/wikipedia/commons/0/05/Scikit_learn_logo_small.svg' },
        { name: 'Machine Learning', bgColor: '#edf2f8', icon: 'https://cdn-icons-png.flaticon.com/512/2103/2103633.png' },
        { name: 'Deep Learning', bgColor: '#edf2f8', icon: 'https://cdn-icons-png.flaticon.com/512/8637/8637107.png' },
        { name: 'AI', bgColor: '#edf2f8', icon: 'https://cdn-icons-png.flaticon.com/512/1693/1693746.png' },
        { name: 'LLMs', bgColor: '#edf2f8', icon: 'https://cdn-icons-png.flaticon.com/512/12222/12222588.png' },
        { name: 'Bubble', bgColor: '#edf2f8', icon: '/assets/bubble.png' },
        { name: 'Zapier', bgColor: '#edf2f8', icon: 'https://cdn.worldvectorlogo.com/logos/zapier.svg' },
        { name: 'n8n', bgColor: '#edf2f8', icon: '/assets/n8n.png' },
        { name: 'Microsoft Office', bgColor: '#edf2f8', icon: 'https://upload.wikimedia.org/wikipedia/commons/4/44/Microsoft_logo.svg' },
      ]);
    }
    if (query.includes('testimonials')) {
      return Promise.resolve([
        {
          name: 'Sarah Doe',
          company: 'Google',
          feedback: 'Micael is an exceptional developer who delivered high-quality work on time. Highly recommended!',
          imgurl: 'https://cdn-icons-png.flaticon.com/512/4140/4140048.png',
        },
        {
          name: 'John Smith',
          company: 'Netflix',
          feedback: 'Great understanding of data science and web development. The portfolio looks amazing.',
          imgurl: 'https://cdn-icons-png.flaticon.com/512/4140/4140037.png',
        },
      ]);
    }
    if (query.includes('brands')) {
      return Promise.resolve([
        { _id: '1', name: 'Aivancity', imgUrl: '/assets/aivancity.png' },
        { _id: '2', name: 'CompetivIA', imgUrl: '/assets/competivia.png' },
        { _id: '3', name: 'Arte Charpentier', imgUrl: '/assets/arte.png' },
        { _id: '4', name: 'Pangea Summit', imgUrl: '/assets/pangea.png' },
      ]);
    }

    if (query.includes('abouts')) {
      if (isFrench) {
        return Promise.resolve([
          {
            title: 'Analyse de Données',
            description: 'Spécialisé dans l\'analyse de données et la gestion de la performance pour générer des insights.',
            imgUrl: 'https://cdn-icons-png.flaticon.com/512/2821/2821637.png',
          },
          {
            title: 'Tableaux de Bord',
            description: 'Expérience dans la création de tableaux de bord interactifs avec Power BI, Excel et Python.',
            imgUrl: 'https://cdn-icons-png.flaticon.com/512/9322/9322127.png',
          },
          {
            title: 'Business Intelligence',
            description: 'Transformation de données complexes en informations claires et exploitables pour la décision.',
            imgUrl: 'https://cdn-icons-png.flaticon.com/512/3078/3078971.png',
          },
          {
            title: 'Collaboration',
            description: 'Collaboration avec les équipes Ventes, Produit et Marketing pour soutenir les objectifs.',
            imgUrl: 'https://cdn-icons-png.flaticon.com/512/1256/1256650.png',
          },
        ]);
      }
      return Promise.resolve([
        {
          title: 'Data Analysis',
          description: 'Specialized in data analysis and performance management to drive business insights.',
          imgUrl: 'https://cdn-icons-png.flaticon.com/512/2821/2821637.png', // Analysis icon
        },
        {
          title: 'Dashboards',
          description: 'Experience in creating interactive dashboards using Power BI, Excel, and Python.',
          imgUrl: 'https://cdn-icons-png.flaticon.com/512/9322/9322127.png', // Dashboard icon
        },
        {
          title: 'Business Intelligence',
          description: 'Transforming complex data into clear, actionable insights for decision-making.',
          imgUrl: 'https://cdn-icons-png.flaticon.com/512/3078/3078971.png', // Strategy/BI icon
        },
        {
          title: 'Collaboration',
          description: 'Working with Sales, Product, and Marketing teams to support business goals.',
          imgUrl: 'https://cdn-icons-png.flaticon.com/512/1256/1256650.png', // Team icon
        },
      ]);
    }
    if (query.includes('works')) {
      if (isFrench) {
        return Promise.resolve([
          {
            title: 'FinAI',
            description: 'Un assistant IA conversationnel pour la finance : interactions voix/texte, tableaux de bord temps réel et orchestration de modèles IA pour des recommandations personnalisées.',
            projectLink: 'https://github.com/Nsangou22/Financial-AI',
            codeLink: 'https://github.com/Nsangou22/Financial-AI',
            imgUrl: '/assets/finai_final.png',
            tags: ['FinAI', 'Tout'],
          },
          {
            title: 'Prédiction AFCON',
            description: 'Projet de Machine Learning pour prédire les matchs de la CAN via scraping web automatisé, modèles supervisés et analyse statistique pour l\'aide à la décision.',
            projectLink: 'https://github.com/Nsangou22/Machine-Learning-For-AFcon-Games-Predictions',
            codeLink: 'https://github.com/Nsangou22/Machine-Learning-For-AFcon-Games-Predictions',
            imgUrl: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80',
            tags: ['Prédiction AFCON', 'Tout'],
          },
        ]);
      }
      return Promise.resolve([
        {
          title: 'FinAI',
          description: 'A conversational AI assistant for finance designing voice/text interactions, real-time dashboards for financial indicators, and orchestrating AI models for personalized recommendations.',
          projectLink: 'https://github.com/Nsangou22/Financial-AI',
          codeLink: 'https://github.com/Nsangou22/Financial-AI',
          imgUrl: '/assets/finai_final.png',
          tags: ['FinAI', 'All'],
        },
        {
          title: 'AFCON Prediction',
          description: 'Machine Learning project to predict AFCON match outcomes using automated web scraping, supervised learning models, and statistical analysis for decision support.',
          projectLink: 'https://github.com/Nsangou22/Machine-Learning-For-AFcon-Games-Predictions',
          codeLink: 'https://github.com/Nsangou22/Machine-Learning-For-AFcon-Games-Predictions',
          imgUrl: 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1000&q=80', // High quality soccer/football image
          tags: ['AFCON Prediction', 'All'],
        },
      ]);
    }
    // Return empty array for other queries to prevent crashes
    return Promise.resolve([]);
  },
  create: (doc) => {
    console.log('Mock client created document:', doc);
    return Promise.resolve(doc);
  },
};

export const client = useMock ? mockClient : sanityClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: 'production',
  apiVersion: '2022-02-01',
  useCdn: true,
  token: process.env.REACT_APP_SANITY_TOKEN,
});

const builder = useMock ? null : imageUrlBuilder(client);

export const urlFor = (source) => {
  if (useMock || typeof source === 'string') return source;
  return builder.image(source);
};
